<!--
 * @Author: chengleilei
 * @Date: 2025-09-23 10:21:14
 * @Description: 新增收货地址弹窗
-->
<template>
    <Modal v-model="isShow" :width="600" title="新增收货地址" @on-cancel="onCancel">
        <Form ref="formRef" :label-width="90" :label-colon="true" :rules="rule" :model="formData">
            <FormItem label="地址" prop="addressList">
                <AreaSelect
                    @on-change="onChangeArea"
                    v-model="formData.addressList"
                    placeholder="请选择省市区"
                ></AreaSelect>
                <Input
                    class="mt-10"
                    placeholder="请输入详细地址"
                    type="textarea"
                    v-model="formData.address"
                    maxlength="50"
                    :rows="1"
                />
            </FormItem>
            <FormItem label="联系人" prop="name">
                <Input placeholder="请输入" v-model="formData.name" :maxlength="20" />
            </FormItem>
            <FormItem label="联系手机" prop="mobile">
                <Input placeholder="请输入" v-model="formData.mobile" :maxlength="11" />
            </FormItem>
        </Form>
        <div slot="footer">
            <Button type="text" @click="onCancel">取消</Button>
            <Button type="primary" :disabled="loadings.btnLoading" :loading="loadings.btnLoading" @click="onOk"
                >确定</Button
            >
        </div>
    </Modal>
</template>

<script>
import AreaSelect from '@/components/AreaSelect';
import { MOBILE_REG } from '@/libs/util';
import { apiPurchaseAddressSave } from '@/api/purchase';

export default {
    components: { AreaSelect },
    data() {
        const validateAddress = (rule, value, callback) => {
            if (!value || !value.length) {
                callback(new Error(`请选择省市区`));
            } else if (!this.formData.address) {
                callback(new Error(`请输入详细地址`));
            } else {
                callback();
            }
        };
        const validatePhone = (rule, value, callback) => {
            if (!value) {
                callback(new Error(`请输入联系手机号`));
            } else if (!MOBILE_REG.test(value.trim())) {
                callback(new Error(`联系手机号格式不正确`));
            } else {
                callback();
            }
        };
        return {
            isShow: false,
            loadings: { btnLoading: false },
            formData: {
                addressList: [], // 地址
                provinceId: '',
                provinceName: '',
                cityId: '',
                cityName: '',
                areaId: '',
                areaName: '',
                address: '', // 详细地址
                name: '',
                mobile: '',
            },
            rule: {
                addressList: [{ required: true, validator: validateAddress, trigger: 'blur' }],
                name: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
                mobile: [{ required: true, validator: validatePhone, trigger: 'blur' }],
            },
        };
    },
    methods: {
        // 打开弹窗
        open() {
            this.isShow = true;
        },
        // 弹窗确定
        async onOk() {
            this.$refs['formRef'].validate(async (valid) => {
                if (valid) {
                    const { provinceId, cityId, areaId, address, name, mobile } = this.formData;
                    const params = { provinceId, cityId, areaId, address, name, mobile };
                    this.loadings.btnLoading = true;
                    try {
                        const res = await apiPurchaseAddressSave(params);
                        this.$Message.success('操作成功');
                        this.$emit('success', res);
                        this.onCancel();
                    } finally {
                        this.loadings.btnLoading = false;
                    }
                }
            });
        },
        // 弹窗取消
        onCancel() {
            this.isShow = false;
            this.formData.address = '';
            this.$refs['formRef'].resetFields();
        },
        // change-地址
        onChangeArea(val, selectedData) {
            const [province = {}, city = {}, area = {}] = selectedData; // 省 市 区
            this.formData.provinceId = province.value;
            this.formData.provinceName = province.label;
            this.formData.cityId = city.value;
            this.formData.cityName = city.label;
            this.formData.areaId = area.value;
            this.formData.areaName = area.label;
        },
    },
};
</script>
